<div class="input-group">
    <button
        class="btn stepper-btn"
        type="button"
        [disabled]="!canDecrement()"
        [attr.aria-label]="ariaLabel() + ' decrease'"
        (click)="decrement()"
    >
        -
    </button>
    <input
        class="form-control input-md ps-0 w-100 pe-3 duration-stepper-field"
        type="text"
        readonly
        [value]="displayValue()"
        [class.locked]="!editable()"
        [disabled]="disabled()"
        [required]="required()"
        [attr.aria-label]="ariaLabel()"
        [attr.aria-invalid]="isInvalid()"
        [class.is-valid]="isValid()"
        [class.is-invalid]="isInvalid()"
        (click)="openManualInput()"
        (blur)="touched.set(true)"
    />
    <button
        class="btn stepper-btn"
        type="button"
        [disabled]="!canIncrement()"
        [attr.aria-label]="ariaLabel() + ' increase'"
        (click)="increment()"
    >
        +
    </button>
</div>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
